export { default } from './CardPositivesInfo'
